module.exports = __webpack_public_path__ + "static/media/room-10.09fb921e.jpeg";